<template>
    <div>
        <v-btn icon target="_blank" @click="gamePDFLink(item)">
            <v-icon color="red">fa-file-pdf</v-icon>
        </v-btn>
    </div>
</template>

<script>
  import Vue from 'vue';

  export default {
    props: ["item"],
    methods: {
      gamePDFLink(item) {
        Vue.prototype.$axios.get('alfakodos/' + item.id + '/pdf').then(async res => {
          var fileURL = res.data.fileURL;
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute('download', `${res.data.fileName}.pdf`);
          document.body.appendChild(fileLink);
          fileLink.click();
        });
      }
    }
  }
</script>